import { useState } from "react";
import { useIdleTimer } from "react-idle-timer"
import { useAuth } from "./useAuth.jsx";


export const useIdleTimeout = ({ onIdlePrompt, onActive, idleTime = 1, promptBeforeIdle = 0 }) => {
    const [isIdle, setIdle] = useState(false)
    const { logout_ } = useAuth();

    const handleIdle = () => {
        console.log("Idle logout")
        setIdle(true)
        logout_()
    }

    const handleActive = () => {
        console.log("Idle stay active")
        setIdle(false)
        onActive()
    }

    const handlePrompt = () => {
        console.log("Idle Prompt")
        onIdlePrompt()
    }

    const { activate, idleTimer } = useIdleTimer({
        timeout: idleTime * 1000,
        promptBeforeIdle: promptBeforeIdle * 1000,
        onPrompt: handlePrompt,
        onIdle: handleIdle,
        onActive: handleActive,
        debounce: 500
    })

    return { isIdle, setIdle, idleTimer, activate }

}
